import {createAction} from 'redux-actions';

import callApi from '../../../utils/api/axios';
import {
  exchangeToExistingSearch,
  userFunds as userFundUrl
} from '../../../utils/api/api-endpoint-dictionary';
import {fundToMutualFundAgreementKey} from "../../../utils/fund-utils";

const USER_FUNDS = 'USER_FUNDS';
const SEARCH_EXCHANGE_TO_EXISTING_ROLLOVER = 'SEARCH_EXCHANGE_TO_EXISTING_ROLLOVER';
const SEARCH_EXCHANGE_TO_EXISTING_TRADITIONAL = 'SEARCH_EXCHANGE_TO_EXISTING_TRADITIONAL';
const RESET_SEARCH = 'RESET_SEARCH';



export default function userFunds(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    error: null,
    hasError: false,
    agreementMap: {},
    funds: [{}],
    fundLock: false,
    isExchangeFundsLoading:  false,
    isExchangeFundsLoaded: false,
    hasExchangeFundsFailed: false,
    isExchangeFundsSet: false,
    exchangeFunds:{
      rolloverFunds: [],
      traditionalFunds: []
    }
  },
  { payload, type }
) {
  switch (type) {
    case `${USER_FUNDS}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true
      };
    case `${USER_FUNDS}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        funds: payload.data ? [payload.data] : [{}]
      };

    case `${USER_FUNDS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasError: true,
        funds: [{}],
        error: payload
      };
    case `${SEARCH_EXCHANGE_TO_EXISTING_ROLLOVER}_PENDING`:
      return {
        ...state,
        isExchangeFundsLoaded: false,
        isExchangeFundsLoading: true,
        isExchangeFundsSet: false
      };
    case `${SEARCH_EXCHANGE_TO_EXISTING_ROLLOVER}_FULFILLED`:
      return {
        ...state,
        isExchangeFundsLoaded: true,
        isExchangeFundsLoading: false,
        isExchangeFundsSet: true,
        exchangeFunds: {
          ...state.exchangeFunds,
          rolloverFunds:payload.data && payload.data.length ? payload.data : []
        }
      };

    case `${SEARCH_EXCHANGE_TO_EXISTING_ROLLOVER}_REJECTED`:
      return {
        ...state,
        isExchangeFundsLoaded: true,
        isExchangeFundsLoading: false,
        hasError: true,
        exchangeFunds: {
          ...state.exchangeFunds,
          rolloverFunds : []
        },
        error: payload
      };
    case `${SEARCH_EXCHANGE_TO_EXISTING_TRADITIONAL}_PENDING`:
      return {
        ...state,
        isExchangeFundsLoaded: false,
        isExchangeFundsLoading: true,
        isExchangeFundsSet: false
      };
    case `${SEARCH_EXCHANGE_TO_EXISTING_TRADITIONAL}_FULFILLED`:
      return {
        ...state,
        isExchangeFundsLoaded: true,
        isExchangeFundsLoading: false,
        isExchangeFundsSet: true,
        exchangeFunds: {
          ...state.exchangeFunds,
          traditionalFunds: payload.data && payload.data.length ? payload.data : []
        }
      };

    case `${SEARCH_EXCHANGE_TO_EXISTING_TRADITIONAL}_REJECTED`:
      return {
        ...state,
        isExchangeFundsLoaded: true,
        isExchangeFundsLoading: false,
        hasError: true,
        exchangeFunds: {
          ...state.exchangeFunds,
          traditionalFunds: []
        },
        error: payload
      };
    case `${RESET_SEARCH}`:
      return {
        ...state,
        isExchangeFundsSet: false
      };
    default:
      return state;
  }
}

export const getUserFunds = () => {
  return (dispatch) => {
    const action = createAction(USER_FUNDS)(callApi(userFundUrl));
    return dispatch(action);
  };
};

export const searchExchangeToExistingRollover = (payload) => {
  return (dispatch) => {
    const action = createAction(SEARCH_EXCHANGE_TO_EXISTING_ROLLOVER)(
      callApi(exchangeToExistingSearch, { method: "post", requestBody: fundToMutualFundAgreementKey(payload) }, false, process.env.NODE_ENV === 'development')
    );
    return dispatch(action);
  };
};

export const searchExchangeToExistingTraditional = (payload) => {
  return (dispatch) => {
    const action = createAction(SEARCH_EXCHANGE_TO_EXISTING_TRADITIONAL)(
      callApi(exchangeToExistingSearch, { method: "post", requestBody: fundToMutualFundAgreementKey(payload) }, false, process.env.NODE_ENV === 'development')
    );
    return dispatch(action);
  };
};

export const resetSearch = () => ({
  type: RESET_SEARCH,
  payload: {}
});
